import {Sounds} from '../enums/Sounds.js';
import {MalwearEquipHotkey} from '../ui/utils/MalwearEquipHotkey.js';
import {SendMessageOnClick} from '../ui/utils/SendMessageOnClick.js';
import {Localization} from '../utils/Localization.js';
import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class NotificationModel extends NotifyPropertyChanged {
    private static _instance: NotificationModel;

    static get instance(): NotificationModel {
        if (!NotificationModel._instance) {
            NotificationModel._instance = new NotificationModel();
        }
        return NotificationModel._instance;
    }

    private _params: NotificationParams;
    public get params(): NotificationParams {
        return this._params;
    }

    private constructor() {
        super();
        this._params = new NotificationParams();
    }

    resetParams() {
        this._params = new NotificationParams();
    }

    updateNotification() {
        this.notifyPropertyChanged('params');
    }
}

export class NotificationParams {
    title: string;
    popUpDescription: string;
    popUpDescriptionDetail: string;
    message: SendMessageOnClick = new SendMessageOnClick();
    equip: MalwearEquipHotkey = new MalwearEquipHotkey();
    showSwitchNowObject: boolean = true;
    showEquipObject: boolean = true;
    iconModeLevel: string;
    iconEnabled: boolean = true;
    iconMalwearEnabled: boolean = true;
    iconSpriteName: string;
    iconModeLevelEnabled: boolean = true;
    iconMalwearSpriteName: string;
    closeObjectEnabled: boolean = true;
    titleText: string;
    titleDescription: string;

    // public void ShowText()
    // {
    // 	StartCoroutine(PlayAnim());

    // }

    // IEnumerator PlayAnim()
    // {
    // 	AudioDirector.GetDirector().PlayOneShot(confirmSFX, true);
    // 	Instantiate(fx, switchNowObject.transform.position, Quaternion.identity);

    // 	float finishTime = Time.realtimeSinceStartup + 0.4f;

    // 	Animation anim = switchNowObject.GetComponentInChildren<Animation>();

    // 	if (anim)
    // 	{
    // 		anim.Play("poke");

    // 		while (Time.realtimeSinceStartup < finishTime)
    // 		{
    // 			yield return null;
    // 		}
    // 	}

    // 	AudioDirector.GetDirector().PlayOneShot(sfx, true);
    // 	iconModeLevel.enabled = true;
    // 	popUpDescription.text = titleText;
    // 	popUpDescriptionDetail.text = titleDescription;
    // 	//close button
    // 	Utils.SetActiveRecursively(closeObject, true);
    // 	//open present button
    // 	Utils.SetActiveRecursively(equipObject, false);
    // 	//blob
    // 	Utils.SetActiveRecursively(switchNowObject, false);

    // }

    hideText() {
        this.iconModeLevelEnabled = false;
        this.closeObjectEnabled = false;
        //Utils.SetActiveRecursively(equipObject, true);
        //store strings
        this.titleText = this.popUpDescription;
        this.titleDescription = this.popUpDescriptionDetail;
        this.popUpDescriptionDetail = '';
        this.popUpDescription = Localization.instance.get('RewardScreenDescriptionAlt');
    }
}
